var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.uppyId}},[_c('div',{attrs:{"id":"ThumbnailContainer"}},[_c('v-btn',{attrs:{"icon":"","id":"UppyModal"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("cloud_upload")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }